import i18n from 'helpers/i18n';
import messages from './messages';
import React, { useEffect, useRef, useState } from 'react';
import useProductKey from './useProductKey';
import TokenRedemptionDialog from './TokenRedemptionDialog';
import { Button, TextField } from '@teachstonellc/component-library';

function ActivateProductKey() {
  const pKeyRequest = useProductKey();
  const [productKey, setProductKey] = useState('');
  const [displayForm, setDisplayForm] = useState(false);
  const productKeyInputRef = useRef<HTMLInputElement>(null);
  const activateButtonRef = useRef<HTMLButtonElement>(null);
  const wasDisplayFormOpenRef = useRef(false);
  const [submitAttempt, setSubmitAttempt] = useState(0);
  const lastFocusedAttemptRef = useRef(0);

  useEffect(() => {
    if (displayForm) {
      productKeyInputRef.current?.focus();
    } else if (wasDisplayFormOpenRef.current) {
      activateButtonRef.current?.focus();
    }

    wasDisplayFormOpenRef.current = displayForm;
  }, [displayForm]);

  useEffect(() => {
    if (
      pKeyRequest.isError &&
      !pKeyRequest.isLoading &&
      submitAttempt !== lastFocusedAttemptRef.current
    ) {
      productKeyInputRef.current?.focus();
      lastFocusedAttemptRef.current = submitAttempt;
    }
  }, [pKeyRequest.isError, pKeyRequest.isLoading, submitAttempt]);

  function clearForm() {
    setProductKey('');
    pKeyRequest.reset();
  }

  function togglePKForm() {
    clearForm();
    setDisplayForm(!displayForm);
  }

  function handleSubmit() {
    setSubmitAttempt(attempt => attempt + 1);
    window.localStorage.removeItem('unified_token');
    pKeyRequest.submit(productKey);
  }

  return (
    <div>
      <TokenRedemptionDialog
        confirmation={pKeyRequest.pendingConfirmation}
        isLoading={pKeyRequest.isLoading}
        onConfirm={pKeyRequest.confirmTokenRedemption}
        onCancel={pKeyRequest.cancelTokenRedemption}
      />
      {displayForm ? (
        <React.Fragment>
          <div className="text-sm font-bold text-black mb-3">
            {i18n.ft(messages.activateProductKey)}
          </div>

          <TextField
            ref={productKeyInputRef}
            label={i18n.ft(messages.productKey)}
            showLabel={false}
            aria-label={i18n.ft(messages.productKey)}
            value={productKey}
            error={pKeyRequest.isError ? pKeyRequest.error : undefined}
            onChange={e => setProductKey(e.target.value)}
          />

          <div className="flex items-center gap-2 mt-2">
            <Button
              fullWidth
              size="small"
              variant="secondary"
              disabled={pKeyRequest.isLoading}
              onClick={togglePKForm}
            >
              {i18n.ft(messages.cancel)}
            </Button>
            <Button
              fullWidth
              size="small"
              variant="primary"
              loading={pKeyRequest.isLoading}
              disabled={pKeyRequest.isLoading}
              onClick={handleSubmit}
            >
              {i18n.ft(messages.activate)}
            </Button>
          </div>
        </React.Fragment>
      ) : (
        <Button
          ref={activateButtonRef}
          fullWidth
          size="small"
          variant="primary"
          onClick={togglePKForm}
        >
          {i18n.ft(messages.activateProductKey)}
        </Button>
      )}
    </div>
  );
}

export default ActivateProductKey;
